import { Component, OnInit } from '@angular/core';
import { EnumDataService } from 'src/app/services/enum-data.service';
// import { EnumDataService } from '@app/services/enum-data.service';

@Component({
  selector: 'app-call-notification',
  templateUrl: './call-notification.component.html',
  styleUrls: ['./call-notification.component.scss']
})
export class CallNotificationComponent implements OnInit {

  exotelData: any;
  exotelDescription: any;

  constructor(private enumDataService: EnumDataService) { }

  ngOnInit() {
    this.enumDataService.exotelNumber$.subscribe(number => {
      console.log('Exotel data received:', number);

      if (number) {
        this.exotelData = number;
        console.log('Exotel data received:', number);
        // Optionally show notification here
      }
    });

    this.enumDataService.exotelDescription$.subscribe(description => {
      if (description) {
        console.log("Exotel description receved", this.exotelDescription);
        this.exotelDescription = description.scheduleDescription

      }
      else {
        this.exotelDescription = null

      }


    })
  }

  closeCallPopup() {
    this.enumDataService.setAdvisorPopupValue(false);  // Notify AppComponent
  }

}



